import { enLang } from 'interfaces/IProductData';

function findLang(lang: string) {
  return Object.values(enLang)
    .reverse()
    .find((langEnum) => langEnum.includes(lang));
}

export function getLanguegByNavigator() {
  const [lang, countryMacro] = (navigator.language || navigator.languages[0]).toLowerCase().split('-');
  const newLang = findLang(lang);

  return { lang: newLang || enLang.EN_US, countryMacro };
}

export function getCountryByLang(langUrl: enLang) {
  const hashMap = {
    [enLang.EN_US]: 'us',
    [enLang.PT_PT]: 'pt',
    [enLang.PT_BR]: 'br'
  };

  const lang = findLang(langUrl) || enLang.PT_BR;
  const countryMacro = hashMap[lang] || 'br';

  return { lang, countryMacro };
}
